var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryClosed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    viewBox: "0 0 5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62782 3.57247C4.76036 3.71262 4.83492 3.90341 4.83492 4.10244C4.83492 4.30146 4.76036 4.49225 4.62782 4.63241L1.82733 7.61815C1.69692 7.75605 1.52091 7.83379 1.33724 7.83461C1.15115 7.83576 0.972279 7.75787 0.840152 7.61815C0.70761 7.47799 0.633057 7.28721 0.633057 7.08818C0.633057 6.88915 0.70761 6.69836 0.840152 6.55821L3.14356 4.10244L0.854155 1.64666C0.676562 1.45732 0.607204 1.18135 0.672208 0.922712C0.737211 0.664069 0.9267 0.462046 1.1693 0.392743C1.41189 0.32344 1.67074 0.397385 1.84833 0.586725L4.62782 3.57247Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryClosed);
export default __webpack_public_path__ + "static/media/category-closed.c4de6d92705345c1cb866f86100fbf78.svg";
export { ForwardRef as ReactComponent };